import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { DepotContextService } from '../services/depot-context.service';
import { AuthServiceService } from '../../../../apis/auth-api/client';

export const depotContextGuard: CanActivateFn = async (): Promise<boolean | UrlTree> => {
  const context = inject(DepotContextService);
  const authApi = inject(AuthServiceService);
  const router = inject(Router);

  if (context.current()) return true;

  const res = await firstValueFrom(authApi.authServiceListDepots());
  const depots = res.depots;
  if (depots.length === 0) {
    return router.createUrlTree(['/login'], { queryParams: { error: 'no-depot-access' } });
  }
  if (depots.length === 1) {
    context.select(depots[0]);
    return true;
  }
  return router.createUrlTree(['/depot-picker']);
};
